import TextOnly from './TextOnly'

export default TextOnly
